import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/Layout';
import Login from './pages/Login';

const Dashboard = lazy(() => import('./pages/dashboard/Dashboard'));
const Management = lazy(() => import('./pages/management/Management'));
const Performance = lazy(() => import('./pages/performance/Performance'));
const ImportPage = lazy(() => import('./pages/performance/ImportPage'));
const Leaderboard = lazy(() => import('./pages/leaderboard/Leaderboard'));
const Alerts = lazy(() => import('./pages/alerts/Alerts'));
const AnalysisCenter = lazy(() => import('./pages/analysis/AnalysisCenter'));
const TargetManagement = lazy(() => import('./pages/targets/TargetManagement'));
const BusinessTypes = lazy(() => import('./pages/management/BusinessTypes'));
const Accounts = lazy(() => import('./pages/accounts/Accounts'));
const OperationLogs = lazy(() => import('./pages/logs/OperationLogs'));
const MyDepartment = lazy(() => import('./pages/org/MyDepartment'));


const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
    <Spin size="large" />
  </div>
);

function LazyRoute({ children }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

export default function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{
      token: {
        colorPrimary: '#667eea',
        colorBgContainer: '#ffffff',
        colorBgElevated: '#ffffff',
        colorText: '#2c3e50',
        colorTextSecondary: '#CBD5E1',
        colorBorder: 'rgba(102, 126, 234, 0.12)',
        colorBorderSecondary: 'rgba(102, 126, 234, 0.06)',
        borderRadius: 10,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Segoe UI', Roboto, sans-serif",
      },
    }}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<LazyRoute><Dashboard /></LazyRoute>} />
              <Route path="management" element={
                <LazyRoute><Management /></LazyRoute>
              } />
              <Route path="performance" element={<LazyRoute><Performance /></LazyRoute>} />
              <Route path="import" element={
                <LazyRoute><ProtectedRoute allowedRoles={['gm', 'dept_manager']}><ImportPage /></ProtectedRoute></LazyRoute>
              } />
              <Route path="targets" element={
                <LazyRoute><TargetManagement /></LazyRoute>
              } />
              <Route path="leaderboard" element={<LazyRoute><Leaderboard /></LazyRoute>} />
              <Route path="alerts" element={
                <LazyRoute><Alerts /></LazyRoute>
              } />
              <Route path="org" element={<LazyRoute><MyDepartment /></LazyRoute>} />
              <Route path="analysis" element={
                <LazyRoute><AnalysisCenter /></LazyRoute>
              } />
              <Route path="accounts" element={
                <LazyRoute><ProtectedRoute allowedRoles={['gm', 'dept_manager']}><Accounts /></ProtectedRoute></LazyRoute>
              } />
              <Route path="logs" element={
                <LazyRoute><ProtectedRoute allowedRoles={['gm']}><OperationLogs /></ProtectedRoute></LazyRoute>
              } />
              
              <Route path="biz-types" element={
                <LazyRoute><BusinessTypes /></LazyRoute>
              } />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
}
